import { render, staticRenderFns } from "./edit-advisory-message.vue?vue&type=template&id=9148b3a0&scoped=true&"
import script from "./edit-advisory-message.vue?vue&type=script&lang=js&"
export * from "./edit-advisory-message.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9148b3a0",
  null
  
)

export default component.exports